/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import {  Departement, Individu } from '@/types';

import { validationInformationsNaissance } from '..';

const validationStep3 = (
  individu: Partial<Individu>,
) => (_.pickBy({
  parent1: validationInformationsNaissance(
      individu?.parent1,
      true,
      individu?.filiationInconnueParent1,
  ),
  parent2: validationInformationsNaissance(
      individu?.parent2,
      true,
      individu?.filiationInconnueParent2,
  ),
  }, v => !_.isNil(v) && !_.isEmpty(v))
);

export default validationStep3;
